<template>
  <div class="signup-wrapper">
    <div style="width: 100%;">
      <v-alert class="mb-2" variant="outlined" type="success" border="top" v-if="loggedIn">
        Authenticated successfully
      </v-alert>
      <v-alert class="mb-2" variant="outlined" type="error" border="top" v-if="error">
        {{ message }}
      </v-alert>
      <v-card style="width: 100%;">
        <v-card-title class="text-h5">
          Additional information
        </v-card-title>
        <v-card-text class="align-center justify-center w-100 mt-2">
          <span class="text-caption font-weight-thin">We just need some more information to create your account</span>
        </v-card-text>
        <v-card-text>
          <v-form>
            <v-text-field class="ma-1" hide-details="auto" label="First name" outlined dense
              @input="onFirstnameInput">
            </v-text-field>
            <v-text-field class="ma-1" hide-details="auto" label="Last name" outlined dense
              @input="onLastnameInput">
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="align-center justify-center w-100">
          <v-btn color="#002394" @click="login_email" variant="flat" class="w-100" block>Signup</v-btn>
          <v-progress-circular size="small" color="#006D94" indeterminate v-if="loading"></v-progress-circular>
        </v-card-actions>
        <v-divider class="ma-2 mt-4"></v-divider>
        <v-card-actions class="align-center justify-center w-100">
          <a class="text-caption" target="_blank" href="https://www.hamburgportconsulting.com/contact/">Problems?</a>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../config.js';
import { msalInstance } from "../msalConfig.js";

export default {
  data() {
    return {
      email: '',
      firstname: '',
      lastname: '',
      error: false,
      loggedIn: false,
      loading: false,
      user: null,
      message: '',
    };
  },
  mounted() {
    document.title = 'DISlog Signup'
    this.email = this.$route.query.email;
    if (this.email === '' || this.email === undefined) {
        this.error = true;
        this.loading = false;
        this.message = 'No account given. Please restart the signup';
    }
  },
  methods: {
    onFirstnameInput(event) {
      this.firstname = event.target.value;
    },
    onLastnameInput(event) {
      this.lastname = event.target.value;
    },
    async login_email(event) {

      // check email address in backend
      this.loading = true;

      if (this.email === '' || this.email === undefined) {
        this.error = true;
        this.loading = false;
        this.message = 'There was a problem during signup. Please restart';
      }
      else {
        axios.post(`${config.baseURL}/api/v1/ms-signup/`, {
          username: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
        })
          .then(async response => {
            this.error = false;
            const status = response.data.status;
            if (status === 'ok') {
              const token = response.data.token;
              localStorage.setItem('token', token);
              this.$router.push({path: '/'});
            }
            else {
              this.error = true;
              this.loading = false;
              this.$router.push({path: '/login', query: { error: true } });
              this.$emit('login-failed');
            }
          })
          .catch(error => {
            console.debug(error)
            this.error = true;
            this.loading = false;
            this.$router.push({path: '/login', query: { error: true } });
            this.$emit('login-failed');
          });
      }
    },
    async login_microsoft(event) {

      this.loading = true;
      try {
        await msalInstance.initialize();
        const loginRequest = {
          scopes: ["user.read"],
        };
        msalInstance.handleRedirectPromise().then((tokenResponse) => {
          console.debug(tokenResponse)
          let accountObj = null;
          if (tokenResponse !== null) {
            accountObj = tokenResponse.account;
            const id_token = tokenResponse.idToken;
            const access_token = tokenResponse.accessToken;
            console.debug(tokenResponse)
            console.debug(access_token)
          }
          else {
            const currentAccounts = msalInstance.getAllAccounts();
            if (!currentAccounts || currentAccounts.length === 0) {
              // No user signed in
              return;
            } else if (currentAccounts.length > 1) {
              // More than one user signed in, find desired user with getAccountByUsername(username)
            } else {
              accountObj = currentAccounts[0];
            }
          }

          const username = accountObj.username;

        }).catch((error) => {
          handleError(error);
        });
        msalInstance.loginPopup(loginRequest).then(response => {
          const access_token = response.idToken;
          const username = response.account.username

          // Validate token
          axios.post(`${config.baseURL}/api/v1/ms-token-check/`, {
            access_token: access_token,
            username: username,
          })
            .then(response => {
              const is_valid = response.data.is_valid;
              if (is_valid) {
                const token = response.data.token;
                localStorage.setItem('token', token);
                console.log("logged in")
                this.$emit('login-success');
                this.$router.push('/signup');
              }
              else {
                const message = response.data.message;
                this.error = true;
                this.loading = false;
                this.message = 'The login failed: ' + message;
                this.$emit('login-failed');
              }
            })
        }
        ).catch(e => {
          this.error = true;
          this.loading = false;
          this.message = 'The login was cancelled';
          this.$emit('login-failed');
        }
        );
      }
      catch (error) {
        this.error = true;
        this.loading = false;
        this.message = 'The login was cancelled';
        this.$emit('login-failed');
      }
    }
  },
  onPasswordInput(event) {
    this.password = event.target.value;
  },
  async login() {
    this.loading = true;
    this.error = false;
    this.loggedIn = false;
    try {
      await msalInstance.initialize();
      const loginRequest = {
        scopes: ["user.read"],
      };
      msalInstance.handleRedirectPromise().then((tokenResponse) => {
        console.debug(tokenResponse)
        let accountObj = null;
        if (tokenResponse !== null) {
          accountObj = tokenResponse.account;
          const id_token = tokenResponse.idToken;
          const access_token = tokenResponse.accessToken;

          console.debug(id_token)
          console.debug(access_token)
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (!currentAccounts || currentAccounts.length === 0) {
            // No user signed in
            return;
          } else if (currentAccounts.length > 1) {
            // More than one user signed in, find desired user with getAccountByUsername(username)
          } else {
            accountObj = currentAccounts[0];
          }
        }

        const username = accountObj.username;

      }).catch((error) => {
        handleError(error);
      });
      msalInstance.loginPopup(loginRequest).then(resp => { console.log(resp) });

      console.debug(tokenResponse)

      this.user = {
        name: tokenResponse.account.name,
        email: tokenResponse.account.username,
      };

      axios.post(`${config.baseURL}/api/v1/login/`, {
        username: tokenResponse.account.username,
        password: this.password,
        ms_sso: true,
      })
        .then(response => {
          setTimeout(() => {
            this.loggedIn = true;
            this.loading = false;
          }, 1000);
          setTimeout(() => {
            this.$emit('login-success');
            this.$router.push('/');
          }, 2000);
          this.error = false;
          const token = response.data.token;
          localStorage.setItem('token', token);

        })
        .catch(error => {
          this.error = true;
          this.loading = false;
          this.message = 'Could not authenticate. Please check email and password.';
          this.$emit('login-failed');
        });



    } catch (error) {
      console.error("Login fehlgeschlagen", error);
    }

    /*axios.post(`${config.baseURL}/api/v1/login/`, {
      username: this.email,
      password: this.password,
    })
      .then(response => {
        setTimeout(() => {
          this.loggedIn = true;
          this.loading = false;
        }, 1000);
        setTimeout(() => {
          this.$emit('login-success');
          this.$router.push('/');
        }, 2000);
        this.error = false;
        const token = response.data.token;
        localStorage.setItem('token', token);
   
      })
      .catch(error => {
        this.error = true;
        this.loading = false;
        this.message = 'Could not authenticate. Please check email and password.';
        this.$emit('login-failed');
      });*/
  },
};
</script>

<style scoped>
.signup-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 48px);
  min-height: calc(100dvh - 48px);
  width: 360px;
  margin: 0 auto;
  padding: 16px 0;
  box-sizing: border-box;
}

.signup-wrapper :deep(.v-card) {
  background: rgba(255, 255, 255, 0.55) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
}

.signup-wrapper :deep(.v-btn--variant-flat) {
  background: rgba(0, 35, 148, 0.8) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 35, 148, 0.2) !important;
}

.signup-wrapper :deep(.v-text-field .v-field) {
  background: rgba(255, 255, 255, 0.4) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  border-radius: 12px !important;
}

.signup-wrapper :deep(.v-alert) {
  background: rgba(255, 255, 255, 0.5) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border-radius: 12px !important;
  flex-shrink: 0;
}

.signup-wrapper :deep(.v-divider) {
  opacity: 0.3;
}
</style>